var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSx = function SvgIconSx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.957 13.043s-7.435-9.53-7.442-9.529A11.96 11.96 0 0 1 12-.001c6.627 0 12 5.373 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M10.957 12s-7.435 8.487-7.442 8.485A11.96 11.96 0 0 0 12 24c6.627 0 12-5.373 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.316 12a3.391 3.391 0 1 0 6.76 0zM4.696 10.434a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.087"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M2.348 9.13v3.391c0 1.798 2.347 2.348 2.347 2.348s2.348-.55 2.348-2.348v-3.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M4.697 13.778c-.435-.157-1.305-.558-1.305-1.256v-2.348H6v2.348c0 .7-.87 1.1-1.303 1.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M5.217 11.478v-.522l-.521-.26-.522.26v.522l-.26.26v1.044h1.564v-1.043z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSx;